import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { CheckboxInput, LightButton, PrimaryButton } from '../../../components';

import { useForm, useFormValidation } from '../../../hooks';
import { useAsistentes } from '../hooks/useAsistentes';

import styles from '../Asistentes.module.css';

export const PermisosUpdate = ({ asistente }) => {

    const { updateAsistentePermisosMutation: { mutate: updateAsistentePermisos, isPending } } = useAsistentes();

    const [dataStatus, setDataStatus] = useState(false);
    
    const [singleInputStatus, setSingleInputStatus] = useState(false);
    
    const [multipleInputStatus, setMultipleInputStatus] = useState(false);

    const { agenda, agendaInmunoterapia, paciente, pacienteCreate, pacienteRead, pacienteUpdate, pacienteDelete, app, cita, citaCreate, citaRead, citaUpdate, citaDelete, evento, eventoCreate, eventoRead, eventoUpdate, eventoDelete, inmunoterapia, inmunoterapiaCreate, inmunoterapiaRead, inmunoterapiaUpdate, inmunoterapiaDelete, consulta, consultaCreate, consultaRead, consultaUpdate, receta, pruebaAlergia, pruebaAlergiaCreate, pruebaAlergiaRead, pruebaAlergiaUpdate, laboratorio, laboratorioCreate, laboratorioRead, laboratorioUpdate, radiologia, radiologiaCreate, radiologiaRead, radiologiaUpdate, antecedentes, antecedentesRead, antecedentesUpdate, escalaControl, escalaControlRead, escalaControlUpdate, historial, estadisticas, onInputChange, onMultipleInputChange, onResetForm } = useForm({ agenda: asistente.permisos.agenda, agendaInmunoterapia: asistente.permisos.agendaInmunoterapia, paciente: (asistente.permisos.pacienteCreate && asistente.permisos.pacienteRead && asistente.permisos.pacienteUpdate && asistente.permisos.pacienteDelete) ? true : false, pacienteCreate: asistente.permisos.pacienteCreate, pacienteRead: asistente.permisos.pacienteRead, pacienteUpdate: asistente.permisos.pacienteUpdate, pacienteDelete: asistente.permisos.pacienteDelete, app: asistente.permisos.app, cita: (asistente.permisos.citaCreate && asistente.permisos.citaRead && asistente.permisos.citaUpdate && asistente.permisos.citaDelete) ? true : false, citaCreate: asistente.permisos.citaCreate, citaRead: asistente.permisos.citaRead, citaUpdate: asistente.permisos.citaUpdate, citaDelete: asistente.permisos.citaDelete, evento: (asistente.permisos.eventoCreate && asistente.permisos.eventoRead && asistente.permisos.eventoUpdate && asistente.permisos.eventoDelete) ? true : false, eventoCreate: asistente.permisos.eventoCreate, eventoRead: asistente.permisos.eventoRead, eventoUpdate: asistente.permisos.eventoUpdate, eventoDelete: asistente.permisos.eventoDelete, inmunoterapia: (asistente.permisos.inmunoterapiaCreate && asistente.permisos.inmunoterapiaRead && asistente.permisos.inmunoterapiaUpdate) ? true : false, inmunoterapiaCreate: asistente.permisos.inmunoterapiaCreate, inmunoterapiaRead: asistente.permisos.inmunoterapiaRead, inmunoterapiaUpdate: asistente.permisos.inmunoterapiaUpdate, inmunoterapiaDelete: asistente.permisos.inmunoterapiaDelete, consulta: (asistente.permisos.consultaCreate && asistente.permisos.consultaRead && asistente.permisos.consultaUpdate) ? true : false, consultaCreate: asistente.permisos.consultaCreate, consultaRead: asistente.permisos.consultaRead, consultaUpdate: asistente.permisos.consultaUpdate, receta: asistente.permisos.receta, pruebaAlergia: (asistente.permisos.pruebaAlergiaCreate && asistente.permisos.pruebaAlergiaRead && asistente.permisos.pruebaAlergiaUpdate) ? true : false, pruebaAlergiaCreate: asistente.permisos.pruebaAlergiaCreate, pruebaAlergiaRead: asistente.permisos.pruebaAlergiaRead, pruebaAlergiaUpdate: asistente.permisos.pruebaAlergiaUpdate, laboratorio: (asistente.permisos.laboratorioCreate && asistente.permisos.laboratorioRead && asistente.permisos.laboratorioUpdate) ? true : false, laboratorioCreate: asistente.permisos.laboratorioCreate, laboratorioRead: asistente.permisos.laboratorioRead, laboratorioUpdate: asistente.permisos.laboratorioUpdate, radiologia: (asistente.permisos.radiologiaCreate && asistente.permisos.radiologiaRead && asistente.permisos.radiologiaUpdate) ? true : false, radiologiaCreate: asistente.permisos.radiologiaCreate, radiologiaRead: asistente.permisos.radiologiaRead, radiologiaUpdate: asistente.permisos.radiologiaUpdate, antecedentes: (asistente.permisos.antecedentesRead && asistente.permisos.antecedentesUpdate) ? true : false, antecedentesRead: asistente.permisos.antecedentesRead, antecedentesUpdate: asistente.permisos.antecedentesUpdate, escalaControl: (asistente.permisos.escalaControlRead && asistente.permisos.escalaControlUpdate) ? true : false, escalaControlRead: asistente.permisos.escalaControlRead, escalaControlUpdate: asistente.permisos.escalaControlUpdate, historial: asistente.permisos.historial, estadisticas: asistente.permisos.estadisticas });

    const { isFormValid, formValidationStatus, startFormValidation } = useFormValidation([{field: 'agenda', default: true}, {field: 'agendaInmunoterapia', default: true}, {field: 'paciente', default: true}, {field: 'pacienteCreate', default: true}, {field: 'pacienteRead', default: true}, {field: 'pacienteUpdate', default: true}, {field: 'pacienteDelete', default: true}, {field: 'app', default: true}, {field: 'cita', default: true}, {field: 'citaCreate', default: true}, {field: 'citaRead', default: true}, {field: 'citaUpdate', default: true}, {field: 'citaDelete', default: true}, {field: 'evento', default: true}, {field: 'eventoCreate', default: true}, {field: 'eventoRead', default: true}, {field: 'eventoUpdate', default: true}, {field: 'eventoDelete', default: true}, {field: 'inmunoterapia', default: true}, {field: 'inmunoterapiaCreate', default: true}, {field: 'inmunoterapiaRead', default: true}, {field: 'inmunoterapiaUpdate', default: true}, {field: 'inmunoterapiaDelete', default: true}, {field: 'consulta', default: true}, {field: 'consultaCreate', default: true}, {field: 'consultaRead', default: true}, {field: 'consultaUpdate', default: true}, {field: 'receta', default: true}, {field: 'pruebaAlergia', default: true}, {field: 'pruebaAlergiaCreate', default: true}, {field: 'pruebaAlergiaRead', default: true}, {field: 'pruebaAlergiaUpdate', default: true}, {field: 'laboratorio', default: true}, {field: 'laboratorioCreate', default: true}, {field: 'laboratorioRead', default: true}, {field: 'laboratorioUpdate', default: true}, {field: 'radiologia', default: true}, {field: 'radiologiaCreate', default: true}, {field: 'radiologiaRead', default: true}, {field: 'radiologiaUpdate', default: true}, {field: 'antecedentes', default: true}, {field: 'antecedentesRead', default: true}, {field: 'antecedentesUpdate', default: true}, {field: 'escalaControlRead', default: true}, {field: 'escalaControlUpdate', default: true}, {field: 'historial', default: true}, {field: 'estadisticas', default: true}]);

    const handleChange = (e) => {
        setDataStatus(true);
        setSingleInputStatus(true);
        onInputChange({ target: { name: e.target.name, value: (e.target.value === 'true') } });
    }

    const handleMultipleChange = (e) => {
        setDataStatus(true);
        setMultipleInputStatus(true);
        onInputChange({ target: { name: e.target.name, value: (e.target.value === 'true') } });
    }

    const handleCancelChange = () => {
        onResetForm();
        setTimeout(() => {
            setDataStatus(false);
        }, 1000);
    }

    useEffect(() => {
        setTimeout(() => {
            setDataStatus(false);
        }, 1000);
    }, []);

    const onSubmit = async ( event ) => {
        event.preventDefault();
        
        if(formValidationStatus === 'checked' && isFormValid != null && isFormValid){
            updateAsistentePermisos({ data: { agenda, agendaInmunoterapia, pacienteCreate, pacienteRead, pacienteUpdate, pacienteDelete, app, citaCreate, citaRead, citaUpdate, citaDelete, eventoCreate, eventoRead, eventoUpdate, eventoDelete, inmunoterapiaCreate, inmunoterapiaRead, inmunoterapiaUpdate, inmunoterapiaDelete, consultaCreate, consultaRead, consultaUpdate, receta, pruebaAlergia, pruebaAlergiaCreate, pruebaAlergiaRead, pruebaAlergiaUpdate, laboratorioCreate, laboratorioRead, laboratorioUpdate, radiologiaCreate, radiologiaRead, radiologiaUpdate, antecedentesRead, antecedentesUpdate, escalaControlRead, escalaControlUpdate, historial, estadisticas }, id: asistente._id });
            setDataStatus(false);
        }else{
          startFormValidation();
        }
    
    }

    useEffect(() => {
        if(multipleInputStatus){
            onMultipleInputChange([{ target: { name: 'pacienteCreate', value: paciente } }, { target: { name: 'pacienteRead', value: paciente } }, { target: { name: 'pacienteUpdate', value: paciente } }, { target: { name: 'pacienteDelete', value: paciente } }]);
            setMultipleInputStatus(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paciente])

    useEffect(() => {
        if(singleInputStatus){
            if(pacienteCreate && pacienteRead && pacienteUpdate && pacienteDelete){
                onInputChange({ target: { name: 'paciente', value: true } });
            }else{
                onInputChange({ target: { name: 'paciente', value: false } });
            }
            setSingleInputStatus(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pacienteCreate, pacienteRead, pacienteUpdate, pacienteDelete])

    useEffect(() => {
        if(multipleInputStatus){
            onMultipleInputChange([{ target: { name: 'citaCreate', value: cita } }, { target: { name: 'citaRead', value: cita } }, { target: { name: 'citaUpdate', value: cita } }, { target: { name: 'citaDelete', value: cita } }]);
            setMultipleInputStatus(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cita])

    useEffect(() => {
        if(singleInputStatus){
            if(citaCreate && citaRead && citaUpdate && citaDelete){
                onInputChange({ target: { name: 'cita', value: true } });
            }else{
                onInputChange({ target: { name: 'cita', value: false } });
            }
            setSingleInputStatus(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [citaCreate, citaRead, citaUpdate, citaDelete])

    useEffect(() => {
        if(multipleInputStatus){
            onMultipleInputChange([{ target: { name: 'eventoCreate', value: evento } }, { target: { name: 'eventoRead', value: evento } }, { target: { name: 'eventoUpdate', value: evento } }, { target: { name: 'eventoDelete', value: evento } }]);
            setMultipleInputStatus(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [evento])

    useEffect(() => {
        if(singleInputStatus){
            if(eventoCreate && eventoRead && eventoUpdate && eventoDelete){
                onInputChange({ target: { name: 'evento', value: true } });
            }else{
                onInputChange({ target: { name: 'evento', value: false } });
            }
            setSingleInputStatus(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [eventoCreate, eventoRead, eventoUpdate, eventoDelete])

    useEffect(() => {
        if(multipleInputStatus){
            onMultipleInputChange([{ target: { name: 'inmunoterapiaCreate', value: inmunoterapia } }, { target: { name: 'inmunoterapiaRead', value: inmunoterapia } }, { target: { name: 'inmunoterapiaUpdate', value: inmunoterapia } }, { target: { name: 'inmunoterapiaDelete', value: inmunoterapia } }]);
            setMultipleInputStatus(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inmunoterapia])

    useEffect(() => {
        if(singleInputStatus){
            if(inmunoterapiaCreate && inmunoterapiaRead && inmunoterapiaUpdate && inmunoterapiaDelete){
                onInputChange({ target: { name: 'inmunoterapia', value: true } });
            }else{
                onInputChange({ target: { name: 'inmunoterapia', value: false } });
            }
            setSingleInputStatus(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inmunoterapiaCreate, inmunoterapiaRead, inmunoterapiaUpdate, inmunoterapiaDelete])

    useEffect(() => {
        if(multipleInputStatus){
            onMultipleInputChange([{ target: { name: 'consultaCreate', value: consulta } }, { target: { name: 'consultaRead', value: consulta } }, { target: { name: 'consultaUpdate', value: consulta } }]);
            setMultipleInputStatus(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [consulta])

    useEffect(() => {
        if(singleInputStatus){
            if(consultaCreate && consultaRead && consultaUpdate){
                onInputChange({ target: { name: 'consulta', value: true } });
            }else{
                onInputChange({ target: { name: 'consulta', value: false } });
            }
            setSingleInputStatus(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [consultaCreate, consultaRead, consultaUpdate])

    useEffect(() => {
        if(multipleInputStatus){
            onMultipleInputChange([{ target: { name: 'pruebaAlergiaCreate', value: pruebaAlergia } }, { target: { name: 'pruebaAlergiaRead', value: pruebaAlergia } }, { target: { name: 'pruebaAlergiaUpdate', value: pruebaAlergia } }]);
            setMultipleInputStatus(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pruebaAlergia])

    useEffect(() => {
        if(singleInputStatus){
            if(pruebaAlergiaCreate && pruebaAlergiaRead && pruebaAlergiaUpdate){
                onInputChange({ target: { name: 'pruebaAlergia', value: true } });
            }else{
                onInputChange({ target: { name: 'pruebaAlergia', value: false } });
            }
            setSingleInputStatus(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pruebaAlergiaCreate, pruebaAlergiaRead, pruebaAlergiaUpdate])

    useEffect(() => {
        if(multipleInputStatus){
            onMultipleInputChange([{ target: { name: 'laboratorioCreate', value: laboratorio } }, { target: { name: 'laboratorioRead', value: laboratorio } }, { target: { name: 'laboratorioUpdate', value: laboratorio } }]);
            setMultipleInputStatus(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [laboratorio])

    useEffect(() => {
        if(singleInputStatus){
            if(laboratorioCreate && laboratorioRead && laboratorioUpdate){
                onInputChange({ target: { name: 'laboratorio', value: true } });
            }else{
                onInputChange({ target: { name: 'laboratorio', value: false } });
            }
            setSingleInputStatus(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [laboratorioCreate, laboratorioRead, laboratorioUpdate])

    useEffect(() => {
        if(multipleInputStatus){
            onMultipleInputChange([{ target: { name: 'radiologiaCreate', value: radiologia } }, { target: { name: 'radiologiaRead', value: radiologia } }, { target: { name: 'radiologiaUpdate', value: radiologia } }]);
            setMultipleInputStatus(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [radiologia])

    useEffect(() => {
        if(singleInputStatus){
            if(radiologiaCreate && radiologiaRead && radiologiaUpdate){
                onInputChange({ target: { name: 'radiologia', value: true } });
            }else{
                onInputChange({ target: { name: 'radiologia', value: false } });
            }
            setSingleInputStatus(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [radiologiaCreate, radiologiaRead, radiologiaUpdate])

    useEffect(() => {
        if(multipleInputStatus){
            onMultipleInputChange([{ target: { name: 'antecedentesRead', value: antecedentes } }, { target: { name: 'antecedentesUpdate', value: antecedentes } }]);
            setMultipleInputStatus(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [antecedentes])

    useEffect(() => {
        if(singleInputStatus){
            if(antecedentesRead && antecedentesUpdate){
                onInputChange({ target: { name: 'antecedentes', value: true } });
            }else{
                onInputChange({ target: { name: 'antecedentes', value: false } });
            }
            setSingleInputStatus(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [antecedentesRead, antecedentesUpdate])

    useEffect(() => {
        if(multipleInputStatus){
            onMultipleInputChange([{ target: { name: 'escalaControlRead', value: escalaControl } }, { target: { name: 'escalaControlUpdate', value: escalaControl } }]);
            setMultipleInputStatus(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [escalaControl])

    useEffect(() => {
        if(singleInputStatus){
            if(escalaControlRead && escalaControlUpdate){
                onInputChange({ target: { name: 'escalaControl', value: true } });
            }else{
                onInputChange({ target: { name: 'escalaControl', value: false } });
            }
            setSingleInputStatus(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [escalaControlRead, escalaControlUpdate])

    return (
        <>
            <form onSubmit={onSubmit}>
                <div className={styles.panel}>
                    <div className="row mb-2">
                        <div className="col">
                            <div className={styles.subHeader}>Permisos</div>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col">
                            <CheckboxInput
                                label="Agenda"
                                name="agenda"
                                onChange={ handleChange }
                                required={false}
                                checked={ (agenda === 'true' || agenda === true) ? true : false }
                            />
                        </div>
                        <div className="col">
                            <CheckboxInput
                                label="Agenda de inmunoterapia"
                                name="agendaInmunoterapia"
                                onChange={ handleChange }
                                required={false}
                                checked={ (agendaInmunoterapia === 'true' || agendaInmunoterapia === true) ? true : false }
                            />
                        </div>
                        <div className="col">
                            <CheckboxInput
                                label="Aplicación móvil"
                                name="app"
                                onChange={ handleChange }
                                required={false}
                                checked={ (app === 'true' || app === true) ? true : false }
                            />
                        </div>
                        <div className="col">
                            <CheckboxInput
                                label="Receta"
                                name="receta"
                                onChange={ handleChange }
                                required={false}
                                checked={ (receta === 'true' || receta === true) ? true : false }
                            />
                        </div>
                        <div className="col">
                            <CheckboxInput
                                label="Historial"
                                name="historial"
                                onChange={ handleChange }
                                required={false}
                                checked={ (historial === 'true' || historial === true) ? true : false }
                            />
                        </div>
                        <div className="col">
                            <CheckboxInput
                                label="Estadísticas"
                                name="estadisticas"
                                onChange={ handleChange }
                                required={false}
                                checked={ (estadisticas === 'true' || estadisticas === true) ? true : false }
                            />
                        </div>
                    </div>
                    <div className="row mb-2">
                        <div className="col">
                            <CheckboxInput
                                label="Paciente"
                                name="paciente"
                                onChange={ handleMultipleChange }
                                required={false}
                                checked={ (paciente === 'true' || paciente === true) ? true : false }
                            />
                        </div>
                        <div className="col">
                            <CheckboxInput
                                label="Cita"
                                name="cita"
                                onChange={ handleMultipleChange }
                                required={false}
                                checked={ (cita === 'true' || cita === true) ? true : false }
                            />
                        </div>
                        <div className="col">
                            <CheckboxInput
                                label="Evento"
                                name="evento"
                                onChange={ handleMultipleChange }
                                required={false}
                                checked={ (evento === 'true' || evento === true) ? true : false }
                            />
                        </div>
                        <div className="col">
                            <CheckboxInput
                                label="Inmunoterapia"
                                name="inmunoterapia"
                                onChange={ handleMultipleChange }
                                required={false}
                                checked={ (inmunoterapia === 'true' || inmunoterapia === true) ? true : false }
                            />
                        </div>
                        <div className="col">
                            <CheckboxInput
                                label="Consulta"
                                name="consulta"
                                onChange={ handleMultipleChange }
                                required={false}
                                checked={ (consulta === 'true' || consulta === true) ? true : false }
                            />
                        </div>
                        <div className="col">
                            <CheckboxInput
                                label="Prueba de alergia"
                                name="pruebaAlergia"
                                onChange={ handleMultipleChange }
                                required={false}
                                checked={ (pruebaAlergia === 'true' || pruebaAlergia === true) ? true : false }
                            />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Ver"
                                    name="pacienteRead"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (pacienteRead === 'true' || pacienteRead === true) ? true : false }
                                />
                            </div>
                            <div className="px-3">
                                <CheckboxInput
                                    label="Crear"
                                    name="pacienteCreate"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (pacienteCreate === 'true' || pacienteCreate === true) ? true : false }
                                />
                            </div>
                            <div className="px-3">
                                <CheckboxInput
                                    label="Editar"
                                    name="pacienteUpdate"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (pacienteUpdate === 'true' || pacienteUpdate === true) ? true : false }
                                />
                            </div>
                            <div className="px-3">
                                <CheckboxInput
                                    label="Eliminar"
                                    name="pacienteDelete"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (pacienteDelete === 'true' || pacienteDelete === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Ver"
                                    name="citaRead"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (citaRead === 'true' || citaRead === true) ? true : false }
                                />
                            </div>
                            <div className="px-3">
                                <CheckboxInput
                                    label="Crear"
                                    name="citaCreate"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (citaCreate === 'true' || citaCreate === true) ? true : false }
                                />
                            </div>
                            <div className="px-3">
                                <CheckboxInput
                                    label="Editar"
                                    name="citaUpdate"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (citaUpdate === 'true' || citaUpdate === true) ? true : false }
                                />
                            </div>
                            <div className="px-3">
                                <CheckboxInput
                                    label="Eliminar"
                                    name="citaDelete"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (citaDelete === 'true' || citaDelete === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Ver"
                                    name="eventoRead"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (eventoRead === 'true' || eventoRead === true) ? true : false }
                                />
                            </div>
                            <div className="px-3">
                                <CheckboxInput
                                    label="Crear"
                                    name="eventoCreate"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (eventoCreate === 'true' || eventoCreate === true) ? true : false }
                                />
                            </div>
                            <div className="px-3">
                                <CheckboxInput
                                    label="Editar"
                                    name="eventoUpdate"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (eventoUpdate === 'true' || eventoUpdate === true) ? true : false }
                                />
                            </div>
                            <div className="px-3">
                                <CheckboxInput
                                    label="Eliminar"
                                    name="eventoDelete"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (eventoDelete === 'true' || eventoDelete === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Ver"
                                    name="inmunoterapiaRead"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (inmunoterapiaRead === 'true' || inmunoterapiaRead === true) ? true : false }
                                />
                            </div>
                            <div className="px-3">
                                <CheckboxInput
                                    label="Crear"
                                    name="inmunoterapiaCreate"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (inmunoterapiaCreate === 'true' || inmunoterapiaCreate === true) ? true : false }
                                />
                            </div>
                            <div className="px-3">
                                <CheckboxInput
                                    label="Editar"
                                    name="inmunoterapiaUpdate"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (inmunoterapiaUpdate === 'true' || inmunoterapiaUpdate === true) ? true : false }
                                />
                            </div>
                            <div className="px-3">
                                <CheckboxInput
                                    label="Eliminar"
                                    name="inmunoterapiaDelete"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (inmunoterapiaDelete === 'true' || inmunoterapiaDelete === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Ver"
                                    name="consultaRead"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (consultaRead === 'true' || consultaRead === true) ? true : false }
                                />
                            </div>
                            <div className="px-3">
                                <CheckboxInput
                                    label="Crear"
                                    name="consultaCreate"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (consultaCreate === 'true' || consultaCreate === true) ? true : false }
                                />
                            </div>
                            <div className="px-3">
                                <CheckboxInput
                                    label="Editar"
                                    name="consultaUpdate"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (consultaUpdate === 'true' || consultaUpdate === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Ver"
                                    name="pruebaAlergiaRead"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (pruebaAlergiaRead === 'true' || pruebaAlergiaRead === true) ? true : false }
                                />
                            </div>
                            <div className="px-3">
                                <CheckboxInput
                                    label="Crear"
                                    name="pruebaAlergiaCreate"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (pruebaAlergiaCreate === 'true' || pruebaAlergiaCreate === true) ? true : false }
                                />
                            </div>
                            <div className="px-3">
                                <CheckboxInput
                                    label="Editar"
                                    name="pruebaAlergiaUpdate"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (pruebaAlergiaUpdate === 'true' || pruebaAlergiaUpdate === true) ? true : false }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row mb-2">
                        <div className="col">
                            <CheckboxInput
                                label="Laboratorio"
                                name="laboratorio"
                                onChange={ handleMultipleChange }
                                required={false}
                                checked={ (laboratorio === 'true' || laboratorio === true) ? true : false }
                            />
                        </div>
                        <div className="col">
                            <CheckboxInput
                                label="Radiología"
                                name="radiologia"
                                onChange={ handleMultipleChange }
                                required={false}
                                checked={ (radiologia === 'true' || radiologia === true) ? true : false }
                            />
                        </div>
                        <div className="col">
                            <CheckboxInput
                                label="Antecedentes"
                                name="antecedentes"
                                onChange={ handleMultipleChange }
                                required={false}
                                checked={ (antecedentes === 'true' || antecedentes === true) ? true : false }
                            />
                        </div>
                        <div className="col">
                            <CheckboxInput
                                label="Escala de control"
                                name="escalaControl"
                                onChange={ handleMultipleChange }
                                required={false}
                                checked={ (escalaControl === 'true' || escalaControl === true) ? true : false }
                            />
                        </div>
                        <div className="col">
                            
                        </div>
                        <div className="col">
                            
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Ver"
                                    name="laboratorioRead"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (laboratorioRead === 'true' || laboratorioRead === true) ? true : false }
                                />
                            </div>
                            <div className="px-3">
                                <CheckboxInput
                                    label="Crear"
                                    name="laboratorioCreate"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (laboratorioCreate === 'true' || laboratorioCreate === true) ? true : false }
                                />
                            </div>
                            <div className="px-3">
                                <CheckboxInput
                                    label="Editar"
                                    name="laboratorioUpdate"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (laboratorioUpdate === 'true' || laboratorioUpdate === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Ver"
                                    name="radiologiaRead"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (radiologiaRead === 'true' || radiologiaRead === true) ? true : false }
                                />
                            </div>
                            <div className="px-3">
                                <CheckboxInput
                                    label="Crear"
                                    name="radiologiaCreate"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (radiologiaCreate === 'true' || radiologiaCreate === true) ? true : false }
                                />
                            </div>
                            <div className="px-3">
                                <CheckboxInput
                                    label="Editar"
                                    name="radiologiaUpdate"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (radiologiaUpdate === 'true' || radiologiaUpdate === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Ver"
                                    name="antecedentesRead"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (antecedentesRead === 'true' || antecedentesRead === true) ? true : false }
                                />
                            </div>
                            <div className="px-3">
                                <CheckboxInput
                                    label="Editar"
                                    name="antecedentesUpdate"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (antecedentesUpdate === 'true' || antecedentesUpdate === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col">
                            <div className="px-3">
                                <CheckboxInput
                                    label="Ver"
                                    name="escalaControlRead"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (escalaControlRead === 'true' || escalaControlRead === true) ? true : false }
                                />
                            </div>
                            <div className="px-3">
                                <CheckboxInput
                                    label="Editar"
                                    name="escalaControlUpdate"
                                    onChange={ handleChange }
                                    required={false}
                                    checked={ (escalaControlUpdate === 'true' || escalaControlUpdate === true) ? true : false }
                                />
                            </div>
                        </div>
                        <div className="col">
                            
                        </div>
                        <div className="col">
                            
                        </div>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-sm-12 col-md">
                        <div className='d-flex justify-content-end'>
                            <LightButton
                                disabled={isPending || formValidationStatus === 'checking' || !dataStatus}
                                icon="X"
                                marginTop={false}
                                marginRight={true}
                                onClick={handleCancelChange}
                                text="Cancelar"
                                type="button"
                            />
                            <PrimaryButton
                                disabled={isPending || formValidationStatus === 'checking' || !dataStatus}
                                icon="Check"
                                marginTop={false}
                                text="Guardar"
                                type="submit"
                            />
                        </div>
                    </div>
                </div>
            </form>
        </>
    )
}

PermisosUpdate.propTypes = {
    asistente: PropTypes.object.isRequired
}